import { Directive } from '@angular/core';
import { GridComponent } from '@syncfusion/ej2-angular-grids';
import { Tooltip, TooltipEventArgs } from '@syncfusion/ej2-angular-popups';

@Directive({
    /* eslint-disable-next-line @angular-eslint/directive-selector */
	selector: 'ejs-grid:not([pmsGridTooltipOverride])',
	standalone: false,
})
export class GridTooltipDirective {

	constructor(
		private gridComponent: GridComponent,
	) {
		this.gridComponent?.created?.subscribe(() => {
			const tooltip = this.gridComponent['toolTipObj'] as Tooltip;
			tooltip.beforeRender = args => this.beforeRender(tooltip, args);
		});
	}

	beforeRender(tooltip: Tooltip, args: TooltipEventArgs) {
		// hack to force ejs-grid tooltip to use textContent instead of innerText so whitespace/newlines are preserved
		if (args.target?.textContent && (tooltip.content instanceof HTMLElement)) {
			(tooltip.content as HTMLElement).textContent = args.target.textContent;
		}
	}
}
